<template>
  <div class="text-center">
    <span class="text-h6">{{ chartTitle }}</span>
    <div class="chart-container">
      <canvas ref="chart-container"></canvas>
    </div>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default {
  name: 'MetricChart',
  props: {
    chartTitle: {
      required: false
    },
    chartData: {
      required: true
    }
  },
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let min = this.chartData.datasets[0].data.length > 1 ? this.chartData.datasets[0].data[0] : 0
      let max = this.chartData.datasets[0].data[0]
      for (let i = 0; i < this.chartData.datasets.length; i++) {
        this.chartData.datasets[i].data.forEach(item => {
          if (item < min) min = item
          if (item > max) max = item
        })
      }
      this.chart = new Chart(this.$refs['chart-container'], {
        type: this.chartData.labels.length === 1 ? 'bar' : 'line',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          aspectRatio: 0.75,
          scales: {
            y: {
              suggestedMin: min === 0 ? min : min - ((max - min) / 2),
              suggestedMax: max + ((max - min) / (min === 0 ? 6 : 2))
            }
          },
          plugins: {
            legend: {
              onHover (e) {
                e.native.target.style.cursor = 'pointer'
              },
              onLeave (e) {
                e.native.target.style.cursor = 'default'
              },
              labels: {
                boxWidth: 40,
                boxHeight: 2
              },
              position: 'top'
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .chart-container {
    position: relative;
    max-height: 300px;
  }
</style>
